import { Injectable, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Campaign } from '@core/models/campaign.model';
import { CampaignApiService } from './api/campaign-api.service';
import { GrandCompteService } from './grand-compte.service';
import { AppFacade } from './facades/app.facade';
import { currencyToIso } from '@core/utils/currency.utils';

@Injectable({
    providedIn: 'root',
})
export class CampaignService {
    private campaignApi = inject(CampaignApiService);
    private grandCompteService = inject(GrandCompteService);
    private appFacade = inject(AppFacade);

    loadCampaigns(): Observable<{ page: number; data: Campaign[] }[]> {
        const gc = this.grandCompteService.currentGrandCompteId();
        if (!gc) {
            return throwError(() => new Error('No Grand Compte selected'));
        }
        return this.campaignApi.getCampaigns(gc, currencyToIso(this.appFacade.selectedCurrency)).pipe(
            map((response) => {
                if (response.code === 200 && response.data) {
                    return response.data;
                } else {
                    throw new Error(response?.message || 'Failed to load campaigns');
                }
            }),
        );
    }

    getCampaignById(id: string): Observable<Campaign | undefined> {
        return this.loadCampaigns().pipe(
            map((pages) => {
                const allCampaigns = pages.reduce((campaigns, page) => {
                    return [...campaigns, ...page.data];
                }, [] as Campaign[]);

                return allCampaigns.find((c) => c.insertion_order_id === id);
            }),
            catchError(() => of(undefined)),
        );
    }
}
